<template>
    <div
        :class="['category-item', { dark: theme == THEMES.DARK }, { active: active }]"
        @click="$emit('click')"
    >
        <slot />
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState("misc", ["theme", "THEMES"]),
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.category-item {
    padding: 8px 14px;
    border-radius: 0;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 13px;
    color: $textColor;
    border-left: 3px solid transparent;
    
    &:hover {
        background-color: rgba($primaryColor, 0.08);
    }
    
    &.active {
        background-color: rgba($primaryColor, 0.12);
        color: $primaryColor;
        font-weight: 500;
        border-left: 3px solid $primaryColor;
    }
    
    &.dark {
        color: $darkTextColor;
        
        &:hover {
            background-color: rgba($secondaryColorDark, 0.12);
        }
        
        &.active {
            background-color: rgba($secondaryColorDark, 0.16);
            color: $secondaryColorDark;
            border-left-color: $secondaryColorDark;
        }
    }
}
</style>
